import { render, staticRenderFns } from "./IndividualQmpsCard.vue?vue&type=template&id=28edc36e&scoped=true&"
import script from "./IndividualQmpsCard.vue?vue&type=script&lang=js&"
export * from "./IndividualQmpsCard.vue?vue&type=script&lang=js&"
import style0 from "./IndividualQmpsCard.vue?vue&type=style&index=0&id=28edc36e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28edc36e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSlideYReverseTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VLayout,VSlideYReverseTransition})
